module.exports = __webpack_public_path__ + "img/Skirt-Front-B7-Da-Fb-Hc-Ia.44bb022a.png";